<template>
  <Dialog
    v-model="dialog"
    :title="'新出語彙編集'"
    colorTextYes="red--text"
    :width="500"
  >
    <template v-slot:activator="{ on }">
      <v-icon
        class="ml-5"
        size="medium"
        v-text="`fas fa-pencil-alt`"
        v-on="on"
      />
    </template>
    <template v-slot:content>
      <v-row class="px-4" v-for="lang in language" :key="lang.key">
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-model="name[lang.key]"
          :error-messages="nameErrors"
          @input="$v.name.ja.$touch()"
          @blur="$v.name.ja.$touch()"
          v-if="lang.key == 'ja'"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
            <span class="red--text" v-if="lang.key == 'ja'">*</span>
          </template>
        </v-textarea>
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-model="name[lang.key]"
          v-else
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
          </template>
        </v-textarea>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn
        color="primary"
        small
        :loading="loading"
        @click="updateVocabulary"
        :disabled="loading"
        >更新</v-btn
      >
      <v-btn color @click="dialog = false" small>キャンセル</v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog/Dialog";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// import { updateVocabulary } from "@/api/Vocabulary.api";
export default {
  props: ["item", "index"],
  store: ["vocabularySentence"],
  mixins: [validationMixin],
  components: { Dialog },
  data() {
    return {
      dialog: false,
      loading: false,
      language: [
        { text: "日本語", key: "ja" },
        { text: "英語", key: "en" },
        { text: "中国語", key: "cn" },
        { text: "ベトナム語", key: "vn" },
        { text: "ベンガル語", key: "bn" },
        { text: "ポルトガル語", key: "pt" },
      ],
      name: { ja: "", en: "", cn: "", vn: "", bn: "", pt: "" },
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.ja.$dirty) return errors;
      !this.$v.name.ja.required && errors.push("日本語を入力してください。");
      return errors;
    },
  },
  validations() {
    return {
      name: {
        ja: {
          required,
        },
      },
    };
  },
  watch: {
    dialog: function () {
      this.name = { ...this.item };
    },
  },
  methods: {
    async updateVocabulary() {
      this.loading = true;
      const { name } = this;
      this.vocabularySentence[this.index] = name;
      this.dialog = false;
      this.loading = false;
      this.$emit("resetList");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>